/**
 * Feature flags for reversible feature toggles.
 * Set via REACT_APP_* env vars. Defaults prioritize privacy and minimal exposure.
 *
 * REACT_APP_ARCANA_ENABLED - Arcano (AI personas) feature. When false, Arcano
 *   is hidden from nav, chat, and not loaded. Set to "true" to re-enable.
 *
 * REACT_APP_PROJECTS_ENABLED - Projects feature. When false, Projects is hidden
 *   from nav and not loaded. Set to "true" to re-enable.
 *
 * REACT_APP_ENABLE_ADMIN_CONVERSATION_VIEW - Admin ability to browse/read user
 *   conversations. GDPR-sensitive. When false, admin UI does not show or fetch
 *   conversation content. Set to "true" only with explicit justification.
 */

export const ARCANA_ENABLED =
  process.env.REACT_APP_ARCANA_ENABLED === 'true' || false

export const PROJECTS_ENABLED =
  process.env.REACT_APP_PROJECTS_ENABLED === 'true' || false

export const ENABLE_ADMIN_CONVERSATION_VIEW =
  process.env.REACT_APP_ENABLE_ADMIN_CONVERSATION_VIEW === 'true' || false
